import React, { useState } from "react";
import { SHELL, payoutsApi } from "@/api/connectorPackClient";

export default function PayoutLedgerCard({ ledger, onChanged }) {
  const [busy, setBusy] = useState(null);
  const [err,  setErr]  = useState("");
  const action = async (fn, key) => {
    setBusy(key); setErr("");
    try { await fn(); if (onChanged) await onChanged(); }
    catch (e) { setErr(String(e.message || e)); }
    finally { setBusy(null); }
  };
  if (!ledger) return null;
  return (
    <div style={{ ...SHELL.panel, marginTop: 12 }} data-testid={`payout-ledger-card-${ledger._id}`}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ ...SHELL.h2, color: "#c5a059", textTransform: "none", fontSize: 15 }}>{ledger._id}</h3>
        <span style={SHELL.badge(ledger.status === "COMPLETED" ? "#7AC860" : ledger.status === "FROZEN" ? "#E5484D" : "#E5A23A")}>{ledger.status}</span>
      </div>
      <div style={{ ...SHELL.dim, marginTop: 6 }}>
        Worker {ledger.worker_ref} · {ledger.channel} · {ledger.currency} {ledger.amount_minor} · retries {ledger.retry_count || 0}
      </div>
      {err && <div style={{ ...SHELL.err, marginTop: 6 }}>{err}</div>}
      <div style={{ marginTop: 10 }}>
        <button type="button" style={SHELL.btn(false)} disabled={!!busy} onClick={() => action(() => payoutsApi.retry(ledger._id, "manual retry"), "retry")} data-testid="payout-action-retry">
          {busy === "retry" ? "Queuing…" : "Retry"}
        </button>
        <button type="button" style={SHELL.btn(false)} disabled={!!busy} onClick={() => action(() => payoutsApi.freeze(ledger._id, "adminone freeze"), "freeze")} data-testid="payout-action-freeze">
          {busy === "freeze" ? "Freezing…" : "Freeze"}
        </button>
        <button type="button" style={SHELL.btn(false)} disabled={!!busy} onClick={() => action(() => payoutsApi.release(ledger._id), "release")} data-testid="payout-action-release">
          {busy === "release" ? "Releasing…" : "Release"}
        </button>
      </div>
    </div>
  );
}
